import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import AIContactForm from './AIContactForm';
import Reveal from './Reveal';
import { useLang } from '../context/LanguageContext';

const Contact = () => {
  const { t } = useLang();

  return (
    <section id="contact" className="py-24 px-6 bg-white">
      <div className="max-w-[980px] mx-auto">
        {/* Section Header */}
        <Reveal className="text-center mb-20">
          <h2 className="text-4xl md:text-5xl font-semibold text-[#1D1D1F] mb-4 tracking-tight">
            {t('contact.title')}
          </h2>
          <p className="text-xl text-[#86868B] max-w-2xl mx-auto">
            {t('contact.subtitle')}
          </p>
        </Reveal>

        <Reveal delay={100}>
        <div className="grid md:grid-cols-2 gap-12">
          {/* AI Contact Form */}
          <div>
            <AIContactForm />
          </div>

          {/* Contact Information */}
          <div className="space-y-8">
            <div>
              <h3 className="text-xl font-semibold text-[#1D1D1F] mb-6">{t('contact.infoTitle')}</h3>
              
              <div className="space-y-5">
                <div className="flex items-start space-x-4">
                  <Mail className="w-5 h-5 text-[#86868B] mt-1" strokeWidth={1.5} />
                  <div>
                    <div className="text-xs text-[#86868B] mb-1">{t('contact.email')}</div>
                    <a
                      href="mailto:info@invictaflow.ch"
                      className="text-[#0071E3] hover:underline"
                    >
                      info@invictaflow.ch
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <Phone className="w-5 h-5 text-[#86868B] mt-1" strokeWidth={1.5} />
                  <div>
                    <div className="text-xs text-[#86868B] mb-1">{t('contact.phone')}</div>
                    <a
                      href="tel:+41796969899"
                      className="text-[#0071E3] hover:underline"
                    >
                      +41 79 696 98 99
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <MapPin className="w-5 h-5 text-[#86868B] mt-1" strokeWidth={1.5} />
                  <div>
                    <div className="text-xs text-[#86868B] mb-1">{t('contact.location')}</div>
                    <p className="text-[#1D1D1F]">{t('contact.country')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="pt-8 border-t border-[#D2D2D7]">
              <h3 className="text-lg font-semibold text-[#1D1D1F] mb-4">
                {t('contact.responseTitle')}
              </h3>
              <p className="text-[#86868B]">
                {t('contact.responseText')}
              </p>
            </div>

          </div>
        </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Contact;
